<template>
    <div class="col-xs-9">
        <div class="row row-space-between">
            <div class="col-size-auto">
                <h1 class="pagetitle">
                    {{ title }}
                </h1>
            </div>
            <!--<div class="col-size-auto">
                <p>Viser alle modeller</p>
            </div>-->
        </div>
        <!-- TODO - make unique keys for for-loop -->
        <model-overview-table v-for="(table, index) in tableData" 
                              :key="table.brand" 
                              :table-data="table" 
                              :overviewterms="overviewterms" 
                              :showroom-text="showroomText" 
                              :excel-link="excelLink" 
                              :excel-button-visible="excelButtonVisible" >
        </model-overview-table>
    </div>
</template>

<script>
    import _ from 'qs';
    import ModelOverviewTable from './ModelOverviewTable.vue';
    export default {
        name: 'model-overview-table-container',
        props: {
            title: {
                type: String,
                default: "Showroom"
            },
            overviewterms: {
                type: Object,
                default: undefined
            },
            tableData: {
                type: Array,
                default: undefined
            },
            showroomText: {
                type: Object,
                default: undefined
            },
            excelLink: {
                type: String,
                default: undefined
            },
            excelButtonVisible: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ModelOverviewTable
        }
    }
</script>